import React, {Component} from 'react';
import PropTypes from "prop-types";
import moment from 'moment';
import Api from "../../utils/Api";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import Timeformat from "../../utils/Timeformat";
import ParentCompanySelector from "../../utils/ParentCompanySelector";
import MainUserSelector from "../../utils/MainUserSelector";
import StaticFunctions from "../../utils/StaticFunctions";
import CompanyLicenceModalContainer from "./CompanyLicenceModalContainer";

class TreeStructureDetailContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        reloadStructure: PropTypes.func.isRequired,
        resetCompany: PropTypes.func.isRequired
    };

    static defaultProps = {
        companyId: null
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            companyId: props.companyId,
            company: null,
            inputParams: {},
            inputError: []
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestCompanyDetails = this.requestCompanyDetails.bind(this);
        this.requestAddCompanyLicence = this.requestAddCompanyLicence.bind(this);
        this.getInput = this.getInput.bind(this);
        this.getSelected = this.getSelected.bind(this);
        this.saveEditCompany = this.saveEditCompany.bind(this);
        this.resetInputError = this.resetInputError.bind(this);
        this.addCompanyLicence = this.addCompanyLicence.bind(this);

    }

    componentWillMount() {

        this.requestCompanyDetails();

    }

    componentWillReceiveProps(nextProps, nextContext) {

        if (nextProps.companyId !== this.props.companyId) {
            this.setState({
                companyId: nextProps.companyId,
                company: null,
                inputParams: {}
            }, this.requestCompanyDetails);
        }

    }

    requestCompanyDetails() {

        if (!this.state.companyId) return null;

        const params = {
            action: 'getCompany',
            companyId: this.state.companyId,
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    company: res,
                    inputParams: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    requestAddCompanyLicence(companyId, dateLicencedFrom, dateLicencedTill, productName) {

        if (companyId && dateLicencedFrom && dateLicencedTill && productName) {
            const params = {
                action: 'addCompanyLicence',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                companyId: companyId,
                userId: this.props.baseData.userData.id,
                productName: productName,
                dateLicencedFrom: dateLicencedFrom,
                dateLicencedTill: dateLicencedTill
            };

            const callback = function (res) {
                if (res) {
                    if (res.success) {
                        this.requestCompanies();

                        this.props.baseData.closeModal();
                    }

                    alert(this.translate(res.msgKey));
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback);
        }

    }

    saveEditCompany() {

        const inputParams = this.state.inputParams;

        if (inputParams && inputParams.id && inputParams.name) {
            const parentId = (typeof inputParams.id_parent !== 'undefined') ? inputParams.id_parent : null;
            const params = {
                action: 'editCompany',
                currentCompanyId: this.props.baseData.companies.currentCompany.id,
                id: inputParams.id,
                parentId: parentId,
                rootId: this.getRootIdByCompanyId(parentId),
                name: inputParams.name,
                info: inputParams.info,
                mainUserId: (typeof inputParams.id_main_user !== 'undefined') ? inputParams.id_main_user : null,
                dateDeleted: null
            };

            const callback = function (res) {
                this.resetInputError();

                if (res.success) {
                    alert(this.translate(res.msgKey));

                    if (this.props.reloadStructure) this.props.reloadStructure();
                } else {
                    this.setInputError(res.errors);
                }
            }.bind(this);

            this.api.request('AdminFunctions', params, callback);
        } else {
            this.setInputError(['name']);
        }

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    getSelected(name, event) {

        if (!event) return;

        const inputParams = {...this.state.inputParams};

        if (inputParams) {
            inputParams[name] = event.value;

            this.setState({
                inputParams
            });
        }

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    unselectCompany() {

        if (this.props.resetCompany) this.props.resetCompany(null);

    }

    addCompanyLicence(company, productName) {

        if (company && productName) {
            const timeNow = new moment().unix() * 1000;

            let dateLicencedFrom = null;
            let dateLicencedTill = null;

            if (productName === 'demoLicenceOneMonth') {
                if (company.date_licenced === null || company.date_licenced < timeNow) {
                    dateLicencedFrom = timeNow;
                    dateLicencedTill = new moment().add(30, 'days').unix() * 1000;
                } else {
                    dateLicencedFrom = parseInt(company.date_licenced);
                    dateLicencedTill = parseInt(company.date_licenced) + (60 * 60 * 24 * 30 * 1000);
                }
            } else if (productName === 'initialLicenceOneYear' && company.date_licenced === null) {
                dateLicencedFrom = timeNow;
                dateLicencedTill = new moment().add(1, 'year').add(2, 'weeks').unix() * 1000;
            } else if (productName === 'renewalLicenceOneYear' && company.date_licenced !== null) {
                if (company.date_licenced < timeNow) {
                    dateLicencedFrom = timeNow;
                    dateLicencedTill = new moment().add(1, 'year').unix() * 1000;
                } else {
                    dateLicencedFrom = parseInt(company.date_licenced);
                    dateLicencedTill = parseInt(company.date_licenced) + (60 * 60 * 24 * 365 * 1000);
                }
            } else if (productName === 'renewalLicenceFiveYear' && company.date_licenced !== null) {
                if (company.date_licenced < timeNow) {
                    dateLicencedFrom = timeNow;
                    dateLicencedTill = new moment().add(5, 'year').unix() * 1000;
                } else {
                    dateLicencedFrom = parseInt(company.date_licenced);
                    dateLicencedTill = parseInt(company.date_licenced) + (60 * 60 * 24 * 365 * 1000 * 5);
                }
            }

            if (dateLicencedFrom !== null && dateLicencedTill !== null) {
                this.requestAddCompanyLicence(company.id, dateLicencedFrom, dateLicencedTill, productName);
            }
        }

    }

    setLicenceModal(company) {

        if (!company) return null;

        this.props.baseData.modalData({
            content: <CompanyLicenceModalContainer
                baseData={this.props.baseData}
                company={company}
                onSave={this.addCompanyLicence}
            />,
            height: 300,
            width: 450
        });

    }

    getRootIdByCompanyId(companyId) {

        if (companyId === null) return null;

        const rootCompany = StaticFunctions.findObjectInArray(this.props.baseData.companies.companies, 'id', companyId);

        return (rootCompany !== null) ? rootCompany.id_root : null;

    }

    getCompanyIdForMainUserSelection() {

        if (!this.state.inputParams && !this.state.inputParams.id_parent) return null;

        return this.state.inputParams.id_parent;

    }

    render() {

        if (this.state.companyId === null) return null;
        if (this.state.company === null) return <LoadingSplash color={'dark'}/>;

        const company = this.state.company;
        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;

        const dateCreated = (company.date_created) ? Timeformat.fromUnix(company.date_created).getFormatedDate(format, timezone) : '-';
        const dateLicenced = (company.date_licenced) ? Timeformat.fromUnix(company.date_licenced).getFormatedDate(format, timezone) : '-';
        const dateDeleted = (company.date_deleted) ? Timeformat.fromUnix(company.date_deleted).getFormatedDate(format, timezone) : '-';
        const lastUpdate = (company.last_update) ? Timeformat.fromUnix(company.last_update).getFormatedDate(format, timezone) : '-';

        return (
            <div className="formSettings clearfix" style={{paddingLeft: '10px'}}>
                <div className="treeDetailsBox ma-bo-20 clearfix">
                    <div className="col-lg-12">
                        <div>
                            <nav>
                                <h1>{this.translate('companySettings')}</h1>
                            </nav>
                        </div>

                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('id')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="id"
                                                disabled={true}
                                                value={company.id}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('name')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="name"
                                                className={this.checkInputError('name')}
                                                value={company.name}
                                                isRequired={true}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('parentCompany')}</td>

                                        <td className="text-left">
                                            <ParentCompanySelector
                                                baseData={this.props.baseData}
                                                selectedCompany={company}
                                                onChange={this.getSelected}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('myzskLoginId')}</td>

                                        <td className="text-left">
                                            <MainUserSelector
                                                baseData={this.props.baseData}
                                                selectedCompany={company}
                                                onChange={this.getSelected}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('info')}</td>

                                        <td className="text-left">
                                            <TextAreaField
                                                name="info"
                                                value={company.info}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('locations')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="locationCounter"
                                                disabled={true}
                                                value={company.location_count}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('machines')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="machineCounter"
                                                disabled={true}
                                                value={company.machine_count}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('user')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="userCounter"
                                                disabled={true}
                                                value={company.user_count}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('operator')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="operatorCounter"
                                                disabled={true}
                                                value={company.operator_count}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('pattern')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="patternCounter"
                                                disabled={true}
                                                value={company.pattern_count}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('dateCreated')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="date_created"
                                                disabled={true}
                                                value={dateCreated}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('dateLicenced')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="date_licenced"
                                                disabled={true}
                                                value={dateLicenced}
                                            />
                                        </td>

                                        {/*<td className="bottomLinks">
                                            <button className="optionAddLicence" onClick={() => this.setLicenceModal(company)} title={this.translate('showNote')}>&nbsp;</button>
                                        </td>*/}
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('dateDeleted')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="date_deleted"
                                                disabled={true}
                                                value={dateDeleted}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('lastChange')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="last_update"
                                                disabled={true}
                                                value={lastUpdate}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">&nbsp;</td>

                                        <td className="text-left">
                                            <a className="formButton" onClick={() => this.unselectCompany()}>
                                                {this.translate('cancel')}
                                            </a>

                                            <a className="formButton" onClick={() => this.saveEditCompany()} onKeyDown={(event) => this.enterSaveEditCompany(event)}>
                                                {this.translate('save')}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

export default TreeStructureDetailContainer;
